<div mat-dialog-title>{{ data.title }}</div>
<mat-dialog-content class="max-height">
  <div *amIfTablet>
    <mat-table #table [dataSource]="dataSource" *amIfTablet>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>{{
          'COMPANY_USERS.name' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let user">
          <div>{{ user.name }}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="sectorNumber">
        <mat-header-cell *matHeaderCellDef>{{ 'Sector_Number' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let user">{{ user.sectorNumber }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="location">
        <mat-header-cell *matHeaderCellDef>{{ 'COMPANY_BRANCHES.location' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let user">{{ user.location }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
      ></mat-row>
    </mat-table>

    @if (usersCount > 5) {
    <mat-paginator
      #paginator
      [length]="usersCount"
      [pageSize]="5"
    >
    </mat-paginator>
    }
  </div>
  <div *amIfMobile>
    <mat-list>
      @for (user of data.users; track user) {
      <mat-list-item>
        <h5 matLine>{{ user.name }}</h5>
        <p matLine>{{ user.location }}</p>
      </mat-list-item>
      }
    </mat-list>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary"  mat-dialog-close>
    {{ 'COMPANY_ADD_USERS.cancel' | translate }}
  </button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true">{{ buttonText }}</button>
</mat-dialog-actions>
